import { apiGeneral } from "services";

export function useDriver() {
  const findDriver = async (document: string): Promise<any> => {

    const { data } = await apiGeneral.post<any>('/drivers/find', {document});
    return data;
  };
  return { findDriver };
}
